import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Map } from 'immutable'

import { activeItem, toggleSubmenu } from '../../actions'

function mapStateToProps(state) {
    return {
        selected: state.getIn(['ui', 'userProfile', 'menu', 'active'], []),
        toggles: state.getIn(['ui', 'userProfile', 'menu', 'toggles'], Map()),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ activeItem, toggleSubmenu }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
